export enum GovernanceV2Event {
    // Page entry / nav. PageViewed fires once per V2 page entry; LeftNavClicked per click.
    PageViewed = 'GovernanceV2.PageViewed',
    LeftNavClicked = 'GovernanceV2.LeftNavClicked',

    // Policy Library tab view — fires once per (page entry, tab) after first data load settles.
    PolicyLibraryViewed = 'GovernanceV2.PolicyLibraryViewed',

    // Policy Library interactions.
    AddPolicyClicked = 'GovernanceV2.AddPolicyClicked',
    PolicyRowActionClicked = 'GovernanceV2.PolicyRowActionClicked',
    PolicyNameClicked = 'GovernanceV2.PolicyNameClicked',
    PolicyDeleteConfirmed = 'GovernanceV2.PolicyDeleteConfirmed',

    // Embedded product policy form failed to come up — no 'ready' handshake within the timeout, a missing token,
    // or an embed-reported error.
    ProductPolicyFormLoadFailed = 'GovernanceV2.ProductPolicyFormLoadFailed',

    // Deployment embed failed to load; Reason names which fault so the same error page is diagnosable.
    DeploymentEmbedLoadFailed = 'GovernanceV2.DeploymentEmbedLoadFailed',

    // Deployment business events, reported by the embed over postMessage and re-emitted here. Tenant ids are
    // logged; group and user identities deliberately are not.
    DeploymentViewed = 'GovernanceV2.DeploymentViewed',
    DeploymentTabSelected = 'GovernanceV2.DeploymentTabSelected',
    DeploymentTenantOpened = 'GovernanceV2.DeploymentTenantOpened',
    DeploymentEntityOpened = 'GovernanceV2.DeploymentEntityOpened',
    DeploymentSaved = 'GovernanceV2.DeploymentSaved',
    DeploymentCancelled = 'GovernanceV2.DeploymentCancelled',

    // Product policy form saved successfully via the embed's Save button (success-only — the host can't see save failures).
    ProductPolicyFormSaved = 'GovernanceV2.ProductPolicyFormSaved',

    // Access policy saved successfully via the in-portal v1 wizard's Save (success-only; Create vs Edit flow).
    AccessPolicyFormSaved = 'GovernanceV2.AccessPolicyFormSaved',

    // Compliance Packs (catalog + detail) business events.
    CompliancePacksViewed = 'GovernanceV2.CompliancePacksViewed',
    CompliancePacksEmptyStateViewed = 'GovernanceV2.CompliancePacksEmptyStateViewed',
    CompliancePackDetailViewed = 'GovernanceV2.CompliancePackDetailViewed',
    CompliancePackEnabled = 'GovernanceV2.CompliancePackEnabled',
    CompliancePackDisabled = 'GovernanceV2.CompliancePackDisabled',
    CompliancePackTenantChanged = 'GovernanceV2.CompliancePackTenantChanged',
    CompliancePackViewInLibraryClicked = 'GovernanceV2.CompliancePackViewInLibraryClicked',

    // ── Governance health (default dashboard) + its Governed events drill-in ──
    // Interactions.
    GovernanceHealthKpiClicked = 'GovernanceV2.GovernanceHealthKpiClicked',
    GovernanceHealthTimeRangeChanged = 'GovernanceV2.GovernanceHealthTimeRangeChanged',
    GovernanceHealthRiskAgentClicked = 'GovernanceV2.GovernanceHealthRiskAgentClicked',
    GovernanceHealthRiskRuleClicked = 'GovernanceV2.GovernanceHealthRiskRuleClicked',
    GovernanceHealthViewAgentsClicked = 'GovernanceV2.GovernanceHealthViewAgentsClicked',
    GovernanceHealthViewAllRulesClicked = 'GovernanceV2.GovernanceHealthViewAllRulesClicked',
    GovernanceHealthTracesFilterChanged = 'GovernanceV2.GovernanceHealthTracesFilterChanged',
    GovernanceHealthTraceOrchestratorClicked = 'GovernanceV2.GovernanceHealthTraceOrchestratorClicked',
    GovernanceHealthTracesBackClicked = 'GovernanceV2.GovernanceHealthTracesBackClicked',
    // Scroll / engagement.
    GovernanceHealthTracesScrolled = 'GovernanceV2.GovernanceHealthTracesScrolled',
    GovernanceHealthRiskListScrolled = 'GovernanceV2.GovernanceHealthRiskListScrolled',
    // Reliability.
    GovernanceHealthLoadFailed = 'GovernanceV2.GovernanceHealthLoadFailed',
    GovernanceHealthEmptyStateShown = 'GovernanceV2.GovernanceHealthEmptyStateShown',

    // ── Dashboard library: pre-built templates + the deployments they produce ──
    // Discovery. Opened fires per drawer open, so Opened vs DeployStarted is the drop-off at the form.
    DashboardTemplateOpened = 'GovernanceV2.DashboardTemplateOpened',
    DashboardTemplateAbandoned = 'GovernanceV2.DashboardTemplateAbandoned',

    // Deploy funnel. Started fires per attempt, so Started vs Completed counts the auto-retry too.
    DashboardTemplateDeployStarted = 'GovernanceV2.DashboardTemplateDeployStarted',
    DashboardTemplateDeployCompleted = 'GovernanceV2.DashboardTemplateDeployCompleted',
    // Carries the backend's error code — the only signal for which of the ~20 codes occur in practice.
    DashboardTemplateDeployFailed = 'GovernanceV2.DashboardTemplateDeployFailed',

    // Upgrade of an already-deployed template. AlreadyLatest is a 200 that wrote nothing.
    DashboardUpgradeCompleted = 'GovernanceV2.DashboardUpgradeCompleted',
    DashboardUpgradeFailed = 'GovernanceV2.DashboardUpgradeFailed',

    // Pinning. Three surfaces drive the same write, so Source says which one is actually used.
    DashboardPinToggled = 'GovernanceV2.DashboardPinToggled',

    // Reliability. A failed catalog read hides the whole templates section.
    DashboardTemplatesLoadFailed = 'GovernanceV2.DashboardTemplatesLoadFailed',
}
